package io.horion.auth.api.models.domain.profile

import kotlinx.serialization.Serializable

@Serializable
data class UserRequest(
    val userUuid : String? = null,
    val firstName: String,
    val lastName: String,
    val avatar: String,
    val role: String,
    val city: String = "Douala",             // Ex: Douala, Yaoundé
    val country: String = "Cameroun",        // Ex: Cameroun
    val countryCode: String = "cm",          // Ex: cm
    val timezone: String = "Africa/Douala",
)
